const addQueryParam = (path, queryParam) => {
  if ('string' === typeof path) {
    if (path.includes('?')) {
      return `${path}&${queryParam}`;
    }
    return `${path}?${queryParam}`;
  }
  const { search } = path;
  return {
    ...path,
    search: search ? `${search}&${queryParam}` : `?${queryParam}`,
  };
};

export default addQueryParam;
